module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/292.d54cdf90.png";